import {
  flattenNestedObjects,
  isDefined,
  pickProps,
  SWISS_QR_BILL_PATH,
  SwissQrBillCurrency,
  SwissQrBillData,
} from '@pai/commons'

export interface CmsCreditorAccount {
  id: string
  currency: SwissQrBillCurrency
  iban: string
}
export interface CmsCreditorData {
  createdAt: string
  updatedAt: string
  globalType: string
  name: string
  address: string
  zip: string
  city: string
  country: string
  accounts: [CmsCreditorAccount, CmsCreditorAccount]
}

export function createSwissBillQrCodeSvgUrl(
  origin: string,
  creditor: CmsCreditorData,
  currency: SwissQrBillCurrency,
  message: string,
): string {
  const account = creditor.accounts.find((a) => a.currency === currency) || creditor.accounts[0]
  const data: SwissQrBillData = {
    creditor: {
      ...pickProps(creditor, ['name', 'address', 'zip', 'city', 'country']),
      account: account.iban,
    },
    currency,
    message,
  }
  const flattenedData: Record<string, string | number | undefined> = flattenNestedObjects(data, 'creditor', 'debtor')

  const qp = Object.entries(flattenedData)
    .filter((entry): entry is [string, string | number] => isDefined(entry[1]))
    .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
    .join('&')
  return `${origin}/${SWISS_QR_BILL_PATH}?${qp}`
}
